const baseUrl = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api' : 'https://elentisar-alzaher.ly/api';

export const RECAPTCHA_PUBLIC_KEY = process.env.NODE_ENV === 'development' ? '6LeR3CkqAAAAAFVqXmT8amh8LVnr8JvHpZkWF6br' : '6LdKYagqAAAAAJ_icORYcVP3m7eCz76rfstMhB9g';


export default baseUrl;
